import { CartStore } from '@/app/v2/app/stores/cart.store'
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { Router, RouterLink, RouterLinkActive } from '@angular/router'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-cart-badge',
  templateUrl: './cart-badge.html',
  imports: [RouterLink, RouterLinkActive],
})
export class CartBadge {
  private store = inject(CartStore)
  private router = inject(Router)

  collapsed = input<boolean>(false)

  count = this.store.count
  isNotEmpty() {
    return this.count() > 0
  }

  goToCart() {
    this.router.navigateByUrl('/cart')
  }
}
